module.exports = __webpack_public_path__ + "static/media/btn-guideline-download.32adfb75.png";